import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.boundOnSubmitStart = this.onSubmitStart.bind(this)
    this.boundOnSubmitEnd = this.onSubmitEnd.bind(this)
    this.element.addEventListener("turbo:submit-start", this.boundOnSubmitStart)
    this.element.addEventListener("turbo:submit-end", this.boundOnSubmitEnd)
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.boundOnSubmitStart)
    this.element.removeEventListener("turbo:submit-end", this.boundOnSubmitEnd)
  }

  // Show the sent message and a thinking indicator in the chat window right
  // away, like other chat apps, instead of relying on the page-top progress bar.
  // Appends below any prior turns; the server replaces the whole transcript
  // with the canonical version once the response arrives.
  onSubmitStart() {
    const message = this.inputTarget.value.trim()
    if (message === "") return

    const area = document.getElementById("chat_response")
    if (!area) return

    area.querySelector(".chat-empty-state")?.remove()
    area.appendChild(this.buildQueryBubble(message))
    area.appendChild(this.buildThinkingBubble())
    area.scrollTop = area.scrollHeight
  }

  onSubmitEnd(event) {
    if (event.detail.success) {
      this.inputTarget.value = ""
      this.inputTarget.focus()
      this.inputTarget.style.height = "auto"
    } else {
      // The response never arrived (network error or server failure), so no
      // turbo stream will replace the thinking bubble. Swap it for an error.
      const bubble = document.querySelector("#chat_response .thinking-bubble")
      if (bubble) {
        bubble.classList.remove("thinking-bubble")
        bubble.removeAttribute("role")
        bubble.textContent = "Something went wrong. Please try again."
      }
    }
  }

  buildQueryBubble(message) {
    const bubble = document.createElement("div")
    bubble.className = "query-bubble"

    const label = document.createElement("span")
    label.className = "query-label"
    label.textContent = "You"

    const content = document.createElement("div")
    content.className = "query-content"
    for (const line of message.split("\n")) {
      const p = document.createElement("p")
      p.textContent = line
      content.appendChild(p)
    }

    bubble.appendChild(label)
    bubble.appendChild(content)
    return bubble
  }

  buildThinkingBubble() {
    const bubble = document.createElement("div")
    bubble.className = "response-bubble thinking-bubble"
    bubble.setAttribute("role", "status")

    const dots = document.createElement("div")
    dots.className = "thinking-dots"
    dots.setAttribute("aria-hidden", "true")
    for (let i = 0; i < 3; i++) {
      dots.appendChild(document.createElement("span"))
    }

    const srText = document.createElement("span")
    srText.className = "visually-hidden"
    srText.textContent = "Waiting for a response"

    bubble.appendChild(dots)
    bubble.appendChild(srText)
    return bubble
  }

  // Submit on Enter, allow Shift+Enter for newlines
  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }
}
